import {AdditionalGroup} from '~/helpers/prices/primary/enum'

export const sortByName = (a, b) => {
  if (a.name.ru) {
    if (a.name.ru < b.name.ru) return -1
    if (a.name.ru > b.name.ru) return 1

    return 0
  } else {
    if (a.name < b.name) return -1
    if (a.name > b.name) return 1

    return 0
  }
}

export const sortByPrice = (a, b) => {
  if (a.prices.rub < b.prices.rub) return -1
  if (a.prices.rub > b.prices.rub) return 1

  return 0
}

export const sortById = (a, b) => a.id - b.id

export const sortByCustomKey = (order, key) => (a, b) => {
  return order.indexOf(a[key]) > order.indexOf(b[key])
    ? 1
    : -1
}

export const mapPricesData = prices => {
  return prices.map(price => {
    return {
      id: price.id,
      name: {
        ru: price.name,
        en: price.nameEn
      },
      status: price.statusId,
      group: price.groupId,
      additionalGroup: price.additionalGroupId,
      subtype: price.subtype,
      prices: {
        rub: price.prices.rub / price.step,
        eur: price.prices.eur / price.step,
        usd: price.prices.usd / price.step
      },
      oldPrices: price.oldPrices
    }
  })
}

export const addAdditionalGroupForVols = prices => {
  return prices.map(price => {
    if (
      price.name.ru.includes('ВОЛС') &&
      price.name.ru.includes('ММТС-9') &&
      price.name.ru.includes('Берзарина')
    ) {
      price.additionalGroup = AdditionalGroup.VOLS_MSK
    }

    if (
      price.name.ru.includes('ВОЛС') &&
      !price.name.ru.includes('ММТС-9') &&
      !price.name.ru.includes('Берзарина')
    ) {
      price.additionalGroup = AdditionalGroup.VOLS_SPB
    }

    return price
  })
}